import React from 'react';
import { FaDice, FaSyncAlt, FaVenusMars, FaGlobe, FaEye, FaAt } from 'react-icons/fa';
import {
  TechSection, TechInput, TechSelect, TechButton,
} from '../../styles/techComponents';
import {
  PLATFORMS, ThreeCol, FormRow, Label, Hint, BatchResults,
} from './CreadorPerfilesStyles';
import { PAISES } from './randomProfileFactory';

const BloqueGeneradorAleatorio = (p) => (
  <TechSection title="Generacion automatica aleatoria" style={{ marginBottom: '1.5rem' }}>
    <ThreeCol>
      <FormRow>
        <Label>Plataforma</Label>
        <TechSelect
          value={p.randomPlatform}
          onChange={(e) => p.setRandomPlatform(e.target.value)}
        >
          {PLATFORMS.map((pl) => (
            <option key={pl.id} value={pl.id}>{pl.label}</option>
          ))}
        </TechSelect>
        <Hint>Plataforma destino del lote.</Hint>
      </FormRow>
      <FormRow>
        <Label>Cantidad</Label>
        <TechInput
          type="number" min="1" max="20"
          value={p.randomCount}
          onChange={(e) => p.setRandomCount(parseInt(e.target.value, 10) || 1)}
        />
        <Hint>1 a 20 perfiles por corrida.</Hint>
      </FormRow>
      <FormRow>
        <Label>Semilla (opcional)</Label>
        <TechInput
          type="text"
          placeholder="ej: lote-mayo-2026"
          value={p.randomSeed}
          onChange={(e) => p.setRandomSeed(e.target.value)}
        />
        <Hint>Misma semilla = mismos perfiles.</Hint>
      </FormRow>
    </ThreeCol>
    
    {/* Opciones avanzadas */}
    <ThreeCol style={{ marginTop: '0.75rem' }}>
      <FormRow>
        <Label><FaVenusMars style={{ marginRight: '4px' }}/> Género</Label>
        <TechSelect
          value={p.randomGender || 'mixed'}
          onChange={(e) => p.setRandomGender && p.setRandomGender(e.target.value)}
        >
          <option value="mixed">Mezclado (aleatorio)</option>
          <option value="M">Masculino</option>
          <option value="F">Femenino</option>
          <option value="U">Unisex/Neutral</option>
        </TechSelect>
        <Hint>Género para los nombres de usuario.</Hint>
      </FormRow>
      <FormRow>
        <Label><FaGlobe style={{ marginRight: '4px' }}/> País</Label>
        <TechSelect
          value={p.randomCountry || 'any'}
          onChange={(e) => p.setRandomCountry && p.setRandomCountry(e.target.value)}
        >
          <option value="any">Cualquiera (aleatorio)</option>
          {PAISES.map((pais) => (
            <option key={pais} value={pais}>{pais}</option>
          ))}
        </TechSelect>
        <Hint>País para zona horaria y contexto.</Hint>
      </FormRow>
      <FormRow>
        <Label><FaAt style={{ marginRight: '4px' }}/> Dominio email</Label>
        <TechInput
          type="text"
          placeholder="ej: adbizetesting.com.ar"
          value={p.randomEmailDomain || ''}
          onChange={(e) => p.setRandomEmailDomain && p.setRandomEmailDomain(e.target.value)}
        />
        <Hint>Dejar vacío para usar emails genéricos.</Hint>
      </FormRow>
    </ThreeCol>
    <div style={{ marginTop: '1rem', display: 'flex', alignItems: 'center', gap: '0.75rem', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
      <TechButton
        type="button"
        onClick={p.handleGenerateRandom}
        disabled={p.randomBusy || p.randomCount < 1}
      >
        {p.randomBusy
          ? <><FaSyncAlt /> Generando...</>
          : <><FaEye /> Previsualizar {p.randomCount} perfiles</>}
      </TechButton>
    </div>
    {p.randomResult && (
      <BatchResults>
        <div>
          <span className="ok">Creados: {p.randomResult.created ?? 0}</span>
          {' · '}
          <span className="ok">Actualizados: {p.randomResult.updated ?? 0}</span>
          {Array.isArray(p.randomResult.errors) && p.randomResult.errors.length > 0 && (
            <>
              {' · '}
              <span className="err">Errores: {p.randomResult.errors.length}</span>
            </>
          )}
        </div>
        {Array.isArray(p.randomResult.accounts) && p.randomResult.accounts.length > 0 && (
          <ul style={{ margin: '0.4rem 0 0 1.2rem' }}>
            {p.randomResult.accounts.map((acc, i) => (
              <li key={`acc-${i}`} className="ok">
                {acc.platform}: @{acc.username}
              </li>
            ))}
          </ul>
        )}
        {Array.isArray(p.randomResult.errors) && p.randomResult.errors.length > 0 && (
          <ul style={{ margin: '0.4rem 0 0 1.2rem' }}>
            {p.randomResult.errors.map((e, i) => (
              <li key={`err-${i}`} className="err">
                #{e.index ?? i}: {e.error}
              </li>
            ))}
          </ul>
        )}
      </BatchResults>
    )}
  </TechSection>
);

export default BloqueGeneradorAleatorio;
